import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "./Context/AuthContext";
import { useGlobalContext } from "./Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = () => {
  const { isAuthenticated, setIsAuthenticated , flowChangerToken } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const { baseUrl } = useGlobalContext();

 
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/authentication/login" />;
 };

export default ProtectedRoute;
// useEffect(() => {
// const verifyUser = async () => {
//   // Use isAuthenticated since it's already set based on token
//   if (isAuthenticated) {
//     setLoading(true);
//     try {
//       const response = await fetch(baseUrl + "user/", {
//         headers: {
//           Authorization: `Bearer ${flowChangerToken}`,
//         },
//       });
//       const data = await response.json();

//       if (response.status === 200) {
//         setUserRole(data?.role);
//       } else {
//         // Invalid token
//         Cookies.remove('flowChangerAuthToken');
//         setIsAuthenticated(false);
//         setUserRole(null);
//       }
//     } catch (error) {
//       console.error("Error verifying user:", error);
//       setIsAuthenticated(false);
//       setUserRole(null);
//     } finally {
//       setLoading(false);
//     }
//   } else {
//     // Not authenticated, no need to verify
//     setUserRole(null);
//   }
// };

// verifyUser();
// }, [isAuthenticated, baseUrl, setIsAuthenticated]);

// // Show loading spinner while verifying
// if (loading) {
// return (
//   <div className="flex items-center justify-center h-screen">
//     <ClipLoader />
//     <p>Verifying user...</p>
//   </div>
// );
// }

// // If not authenticated, redirect to login
// if (!isAuthenticated) {
// return <Navigate to="/authentication/login" />;
// }

// // Handle role-based routing
// const currentPath = window.location.pathname;

// if (userRole === "ADMIN" && currentPath.startsWith('/c')) {
// return <Navigate to="/" />;
// }

// if (userRole === "CLIENT" && !currentPath.startsWith('/c')) {
// return <Navigate to="/c" />;
// }

// // If authenticated and on correct role path, render the route
// return <Outlet />;